import { HttpClient, HttpParams } from '@angular/common/http';
import { Component, Inject, TemplateRef, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { ScreenType } from 'src/app/enums/ScreenType';
import { environment } from 'src/app/environments/environments';
import { Visitor } from 'src/app/models/visitor';
import { AumyeResponsiveScreenService } from 'src/app/services/screenResize/aumye-responsive-screen.service';

@Component({
  selector: 'app-user-preapproved-dialog',
  templateUrl: './user-preapproved-dialog.component.html',
  styleUrls: ['./user-preapproved-dialog.component.scss'],
})
export class UserPreapprovedDialogComponent {
  @ViewChild('FetchingDialog', { static: true })
  fetchingDialog: TemplateRef<any>;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: Visitor,
    private screen: AumyeResponsiveScreenService,
    public dialog: MatDialog,
    private httpclient: HttpClient
  ) {
    this.screen.getScreenType().subscribe((screenData) => {
      this.screenSize = screenData;
      this.config = {
        allowNumbersOnly: true,
        length: 4,
        isPasswordInput: false,
        disableAutoFocus: true,
        placeholder: '*',
        inputStyles: {
          width: this.screenSize == ScreenType.Mobile ? '40px' : '80px',
          height: this.screenSize == ScreenType.Mobile ? '35px' : '75px',
        },
      };
    });
  }
  screenSize: ScreenType;
  ScreenType = ScreenType;
  isOtpEntered = false;
  isMatched = false;
  isClickedVerify = false;
  enteredOTP = '';
  config: any;

  onOtpChange(otp: string) {
    if (otp.length == 4) {
      this.enteredOTP = otp;
      this.isOtpEntered = true;
    } else {
      this.isOtpEntered = false;
      this.isClickedVerify = false;
    }
  }
  // matchOTP() {
  //   console.log(this.data, 'this.data');
  //   this.isClickedVerify = true;
  //   this.isMatched = this.fetchSecurityKeyVisitor(this.enteredOTP)
  // }
  isFetching: boolean = false;
  tempList: Visitor[] = [];
  matchOTP() {
    console.log(this.data, 'this.data');
    this.isClickedVerify = true;

    // Assuming this.data contains the visitorId
    this.fetchSecurityKeyVisitor(this.enteredOTP, this.data.visitorID)
      .then((isMatched) => {
        console.log('isMatched');
        this.isMatched = isMatched;
        if (isMatched) {
          console.log('OTP verification successful');
          // Handle successful match
        } else {
          console.log('OTP verification failed');
          // Handle failed match
        }
      })
      .catch((error) => {
        console.error('Error during OTP verification:', error);
        this.isMatched = false;
      });
  }

  fetchSecurityKeyVisitor(key: string, visitorId: string): Promise<boolean> {
    return new Promise((resolve, reject) => {
      const baseServerURL = environment.apiUrl + 'MatchSecurityKeyVisitor';
      this.isFetching = true;

      const dialogRef = this.dialog.open(this.fetchingDialog, {
        disableClose: true,
      });

      const params = new HttpParams()
        .set('key', key)
        .set('visitorId', visitorId);

      this.httpclient.get(baseServerURL, { params }).subscribe(
        (res: any) => {
          this.isFetching = false;
          dialogRef.close();
          console.log(res, 'res');

          // The API now returns { Match: boolean, Message: string }
          const isMatched = res.match === true;
          console.log('Match result:', res);

          resolve(isMatched);
        },
        (error) => {
          dialogRef.close();
          console.error('Error fetching visitor match:', error);
          this.isFetching = false;
          reject(error);
        }
      );
    });
  }
}
